import 'arrive';
import $ from 'jquery';

document.arrive('.block-publications-list-category', { existing: true }, function () {

    var $footer = $('footer');
    var loading = false;
    var $section = $('.block-publications-list-category');
    var currentPage = parseInt($section.data('page'));
    var totalProducts = parseInt($section.data('total'));
    var perPage = parseInt($section.data('per-page'));
    var categoryId = parseInt($section.data('category'));
    var firstProductId = parseInt($section.data('first-product'));
    var ajaxUrl = $section.data('ajax-url');
    var nonce = $section.data('nonce');
    var loadedProducts = perPage;
    
    // Load More on Scroll
    $(window).on('scroll', function() {
        if (loading || loadedProducts >= totalProducts) return;
        
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var footerTop = $footer.length ? $footer.offset().top : $(document).height();
        
        // Carica quando sei a 200px dal footer
        if (scrollTop + windowHeight >= footerTop - 200) {
            loadMoreProducts();
        }
    });
    
    function loadMoreProducts() {
        if (loading) return;
        
        loading = true;
        currentPage++;
        
        $('.category-loading-more').show();
        
        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'load_more_category_products',
                page: currentPage,
                per_page: perPage,
                category: categoryId,
                first_product: firstProductId,
                nonce: nonce
            },
            success: function(response) {
                if (response.success) {
                    var $grid = $('#category-products-grid');
                    var $html = $(response.data.html);
                    // Seleziona i nuovi elementi: preferisci i figli di primo livello
                    var $newItems = $html.filter('*');
                    // Stato iniziale invisibile + leggero shift
                    $newItems.css({ opacity: 0, transform: 'translateY(8px)' });

                    // Append al grid
                    $grid.append($html);

                    // Forza reflow per far partire la transition
                    if ($newItems.length) { $newItems[0].offsetHeight; }

                    // Attiva fade-in
                    $newItems.css({ opacity: 1, transform: 'translateY(0)' });

                    loadedProducts += perPage;
                    
                    if (!response.data.has_more) {
                        loadedProducts = totalProducts;
                    }
                }
                $('.category-loading-more').hide();
                loading = false;
            },
            error: function() {
                $('.category-loading-more').hide();
                loading = false;
            }
        });
    }
});
